import { addReorderItems, fetchOrders, setDeliveryPrefFlow } from '../../redux/modules/orders';
import { chainAPIActions } from '../../redux/middleware/chain';
import { loggedIn, userSignedUp, userApproved, userActive } from '../../routes/conditional';
import { fetchUserV3 } from '../../redux/modules/user';

export const page = {
    path: '/',
    isAllowed: [loggedIn, userSignedUp, userApproved, userActive],
    action: () => chainAPIActions(fetchOrders(), ()=> fetchUserV3(), () => setDeliveryPrefFlow('orders')),
};

export const addReorderItem = {
    actionPath: '/actions/add-reorder-item',
    inputName: 'medicines',
    mapMedicinesToInputValue: (id) => `/actions/add-reorder-item?id=${id}`,
    action: ({ query, state }) => {
      let medicines;
      try {
        const { orders } = state.pendingOrders;
        const { id } = query;
        const order = orders.find(item => item.id === id);
        medicines = order ? order.medicines : [];
      } catch (e) {
        // none
      }
      return addReorderItems(medicines ?? []);
    },
};
